import NAVBAR_HEIGHT from '@/components/boilerplate/NavBar/navBar.styles';
import CUSTOM_TABLE_TITLE_HEIGHT from '@/components/displays/CustomTableTitle.styles';

const resizable = {
  computed: {
    isFullscreen() {
      return this.$store.getters['boilerplate/isModalFullscreen'];
    },
    isModalOpen() {
      return this.$store.getters['boilerplate/isModalOpen'];
    },
    boilerplatePopupHeight() {
      const coef = this.isFullscreen ? 1 : 0.9;
      return this.windowSize.y * coef;
    },
    contentHeight() {
      return this.windowSize.y - NAVBAR_HEIGHT - 24 - 72;
    },
    contentHeightTable() {
      return this.contentHeight - CUSTOM_TABLE_TITLE_HEIGHT;
    },
    controlsContentHeightTable() {
      return this.contentHeight - CUSTOM_TABLE_TITLE_HEIGHT - 24;
    },
    contentHeightSideBar() {
      return this.windowSize.y - NAVBAR_HEIGHT - 16;
    },
  },
  methods: {
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
  },
  data() {
    return {
      windowSize: {
        x: 0,
        y: 0,
      },
    };
  },
};

export default resizable;
